import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { useLocation } from 'react-router';
import { selectDevice } from 'entities/device/lib';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { DashboardSettingsRoutes } from '../../types';
import { DashboardDeviceSettingsTree } from './tree';
import { getDeviceSpecV2 } from 'z3k-parser/model/device-spec/z3k-feature-flags';
import { MaterialHelpPopupUncontrolled } from 'z3k-settings/components/material-utils/help-popup';
import { useNavigateTo } from 'shared/hooks/router';
export const DashboardDeviceSettings = memo(function DashboardDeviceSettings() {
    const { state } = useLocation();
    const { id } = state;
    const device = usePartialAppSelector(selectDevice, id);
    const navigateToDevices = useNavigateTo(DashboardSettingsRoutes.devices);
    if (!device) {
        navigateToDevices();
        return null;
    }
    const { z3k_config, device_type, hardware_type } = device;
    const device_spec = getDeviceSpecV2(device_type?.code, hardware_type?.code);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", rowGap: 1, height: "100%", children: [_jsxs(Box, { display: "flex", width: "100%", overflow: "auto", alignItems: "center", columnGap: 1, children: [_jsx(Typography, { variant: "h5", children: "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u044B\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u044B" }), _jsx(MaterialHelpPopupUncontrolled, { help_id: "dashboard_device_custom_content" })] }), _jsx(Divider, {}), z3k_config && device_spec && (_jsx(DashboardDeviceSettingsTree, { device_id: id, device_type: device_type, z3k_config: z3k_config, device_spec: device_spec }))] }));
});
